import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "checkbox-list" }
const _hoisted_2 = ["checked", "onChange"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_4 = { class: "checkbox-content" }
const _hoisted_5 = {
  class: "sprite-icon icon btn-more__icon",
  width: "18",
  height: "18"
}
const _hoisted_6 = {
  key: 0,
  "xlink:href": "/img/sprite.svg#chevron-top"
}
const _hoisted_7 = {
  key: 1,
  "xlink:href": "/img/sprite.svg#chevron-down"
}
const _hoisted_8 = { class: "btn-more__text" }
const _hoisted_9 = {
  key: 1,
  class: "dropdown-list show"
}
const _hoisted_10 = ["checked", "onChange"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_12 = { class: "checkbox-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_block_ui = _resolveComponent("app-block-ui")!

  return (_openBlock(), _createBlock(_component_app_block_ui, { blocked: _ctx.blocked }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsHead, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "checkbox",
            key: option.id
          }, [
            _createElementVNode("label", null, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: _ctx.isOptionSelected(option),
                onChange: () => _ctx.toggleOption(option)
              }, null, 40, _hoisted_2),
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(option.name), 1),
                _createElementVNode("p", null, _toDisplayString(option.counter), 1)
              ])
            ])
          ]))
        }), 128)),
        (_ctx.optionsTail.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "btn-more",
              onClick: _cache[0] || (_cache[0] = () => _ctx.toggleTail())
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                (_ctx.showTail)
                  ? (_openBlock(), _createElementBlock("use", _hoisted_6))
                  : (_openBlock(), _createElementBlock("use", _hoisted_7))
              ])),
              _createElementVNode("span", _hoisted_8, [
                (_ctx.showTail)
                  ? (_openBlock(), _createBlock(_component_i18n_t, {
                      key: 0,
                      keypath: "ourCars.hide"
                    }))
                  : (_openBlock(), _createBlock(_component_i18n_t, {
                      key: 1,
                      keypath: "ourCars.showMore"
                    }))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showTail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsTail, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "checkbox",
                  key: option.id
                }, [
                  _createElementVNode("label", null, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.isOptionSelected(option),
                      onChange: () => _ctx.toggleOption(option)
                    }, null, 40, _hoisted_10),
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", null, _toDisplayString(option.name), 1),
                      _createElementVNode("p", null, _toDisplayString(option.counter), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["blocked"]))
}